import React, { createRef, useState, useEffect } from "react";
import LogoHeaderAndUsername from "./LogoHeaderAndUsername";
import LogoFooter from "./LogoFooter";
import ErrorContainer from "../controls/ErrorContainer";
import stepPages from "../helpers/steps";
import uris from "../helpers/uris";
import searchParameters from "../helpers/searchParameters";
import axios from "axios";
import PasswordRequirementsContainer from "../controls/PasswordRequirementsContainer";


const ResetPasswordAndConfirm = (props) => {
    let passwordrescomInput = createRef();
    let defaultError =
        "The password could not be changed. Please try again.";

    const defaultResetPasswordText = "Type your new password below";
    const [resetReasonText, setResetReasonText] = useState(defaultResetPasswordText);
    const urlParams = new URLSearchParams(window.location.search);
    const guid = urlParams.get(searchParameters.guidSearchParameter);

    const [userName, setUsername] = useState("");
    const [password, setPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);
    const [errorDescription, setErrorDescription] = useState(null);
    const [clientName, setClientName] = useState("");

    // booleans for password validations
    const [containsUL, setContainsUL] = useState(false) // uppercase letter
    const [containsLL, setContainsLL] = useState(false) // lowercase letter
    const [containsN, setContainsN] = useState(false) // number
    const [containsSC, setContainsSC] = useState(false) // special character
    const [contains12C, setContains12C] = useState(false) // min 12 characters
    const [passwordMatch, setPasswordMatch] = useState(false) // passwords match

    // checks all validations are true
    const [allValid, setAllValid] = useState(false)

    // labels and state boolean corresponding to each validation
    const mustContainData = [
        ["At least 12 characters", contains12C],
        ["1 uppercase letter (A-Z)", containsUL],
        ["1 lowercase letter (a-z)", containsLL],
        ["1 number (0-9)", containsN],
        ["1 special character (excluding & \" ' < > %)", containsSC],
        ["Passwords must match", passwordMatch]
    ]
    const validatePassword = () => {
        let missingReq = false;
        if (password == null || password == undefined)
            return;
        setErrorDescription("");

        // has uppercase letter
        if (password.toLowerCase() != password) setContainsUL(true)
        else {
            setContainsUL(false);
            missingReq = true;
        }

        // has lowercase letter
        if (password.toUpperCase() != password) setContainsLL(true)
        else {
            setContainsLL(false);
            missingReq = true;
        }

        // has number
        if (/\d/.test(password)) setContainsN(true)
        else {
            setContainsN(false);
            missingReq = true;
        }

        // has special character
        let pwRemoveInvalidChars = password.replace(/%/g, '');
        pwRemoveInvalidChars = pwRemoveInvalidChars.replace(/&/g, '');
        pwRemoveInvalidChars = pwRemoveInvalidChars.replace(/"/g, '')
        pwRemoveInvalidChars = pwRemoveInvalidChars.replace(/'/g, '');
        pwRemoveInvalidChars = pwRemoveInvalidChars.replace(/</g, '');
        pwRemoveInvalidChars = pwRemoveInvalidChars.replace(/>/g, '');
        pwRemoveInvalidChars = pwRemoveInvalidChars.replace(/\s/g, '');
        if (/(?!.*[\s%&<>'"])(?=.*\W+)/g.test(pwRemoveInvalidChars)) setContainsSC(true)
        else {
            setContainsSC(false);
            missingReq = true;
        }

        // has 12 characters
        if (password.length >= 12) setContains12C(true)
        else {
            setContains12C(false);
            missingReq = true;
        }

        // passwords match
        if (password !== "" && password === confirmPassword) setPasswordMatch(true)
        else {
            setPasswordMatch(false);
            missingReq = true;
        }

        // all validations passed
        if (!missingReq) setAllValid(true)
        else setAllValid(false)
    }


    if (props.isActive && !guid && !props.resetPasswordToken) {
        props.goToStep(stepPages.UsernameEntry);
    }
    const updateUserName = newname => {
        props.updateUser(newname);
    };

    const updateToken = value => {
        props.setResetPasswordToken(null);
    }

    const updateClientName = value => {
        setClientName(value);
        props.updateClientName(value);
    }

    const reasonText = () => {
        if (resetReasonText) {
            var reasonText = resetReasonText;
            return reasonText;
        }
        else {
            return defaultResetPasswordText;
        }

    }

    const getResetRequest = () => {
        axios({
            method: "get",
            url: uris.resetpassword,
            params: {
                requestGuid: guid
            },
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => {
                if (res.status === 200) {
                    setErrorDescription("");
                    //updateUserName(res.data.userName);
                    setUsername(res.data.userName);
                    setResetReasonText(res.data.resetPasswordReason);
                    updateClientName(res.data.clientName);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 400) {
                    if (error.response.data) {
                        setErrorDescription(error.response.data);
                        return;
                    }
                }
                setErrorDescription(defaultError);
            });
    }

    const submit = () => {
        if (!password || !confirmPassword) {
            setErrorDescription("Please enter and confirm new password.");
            return;
        }
        if (password !== confirmPassword) {
            setErrorDescription("The passwords must match.");
            return;
        }
        if (/(?=.*?[%&<>'"])/g.test(password)) {
            setErrorDescription("Passwords cannot contain the following special characters & ' \" < > %. Please enter a new password");
            return;
        }
        if (/(?=.*?[\s])/g.test(password)) {
            setErrorDescription("Passwords cannot contain whitespace. Please enter a new password");
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        var guid = urlParams.get(searchParameters.guidSearchParameter);
        if (!guid && props.resetPasswordToken) {
            guid = props.resetPasswordToken;
        }
        var form = new FormData();
        form.append("guid", guid);
        form.append("password", password);
        form.append("confirmPassword", confirmPassword);
        axios({
            method: "post",
            url: uris.resetpassword,
            data: form,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => {
                if (res.status === 200) {
                    setErrorDescription("");
                    setResetReasonText(null);
                    props.goToStep(stepPages.ResetPasswordHasBeenReset);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 400) {
                    if (error.response.data) {
                        setErrorDescription(error.response.data);
                        return;
                    }
                }
                setErrorDescription(defaultError);
            });
    };
    useEffect(() => {
        if (props.isActive) {
            setErrorDescription(null);
            if (props.username && props.settings.clientName) {
                setUsername(props.username);
                updateClientName(props.settings.clientName);
                if (props.resetPasswordReason) {
                    setResetReasonText(props.resetPasswordReason);
                }
            }
            else {
                getResetRequest();
            }
            passwordrescomInput.current.focus();
        }
    }, [props.isActive]);

    return (
        <form id={"rpacForm"}>
            <div className="modal-content">
                <LogoHeaderAndUsername username={userName} clientName={clientName} />
                <div>
                    <p className="bold">Password Reset Requirements</p>

                </div>
                <div id={"passwordRequirementsContainer"} style={{ textAlign: 'left', backgroundColor: '#D9D9D94D', padding: '20px', marginBottom: '14px' }}>
                    <p className="bold">Must Include:</p>
                    {mustContainData.map(data => <PasswordRequirementsContainer data={data} />)}
                </div>
                <div>  <p>{reasonText()}</p></div>
                <ErrorContainer errorDescription={errorDescription} />
                <div className="stackLabel">
                    <div>
                        <div className="stackLabelContent">
                            <div>
                                <label id={"rpwLabelPassword"} htmlFor={"rpwPassword"}>
                                    Enter password
                                </label>
                            </div>
                            <input
                                value={password}
                                type="password"
                                className="form-control"
                                id={"rpwPassword"}
                                ref={passwordrescomInput}
                                required
                                onKeyUp={validatePassword}
                                onChange={e => setPassword(e.target.value)}
                                maxLength="20"
                                onPaste={(e) => {
                                    e.preventDefault()
                                    return false;
                                }} 
                            />
                        </div>
                    </div>
                </div>
                <div className="stackLabel">
                    <div>
                        <div className="stackLabelContent">
                            <div>
                                <label
                                    id={"rpwLabelConfirmPassword"}
                                    htmlFor={"rpwConfirmPassword"}
                                >
                                    Re-enter password
                                </label>
                            </div>
                            <input
                                value={confirmPassword}
                                id={"rpwConfirmPassword"}
                                type="password"
                                className="form-control"
                                required
                                onKeyUp={validatePassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                                maxLength="20"
                                onPaste={(e) => {
                                    e.preventDefault()
                                    return false;
                                }} 
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <button id={"rpwButtonSubmit"} disabled={!allValid} style={!allValid ? { backgroundColor: "#D9D9D6" } : {}} type="button" className="button full-width" onClick={submit}>
                        Submit
                    </button>
                </div>
                <div>
                    <LogoFooter />
                </div>

            </div>
        </form>
    );
};

export default ResetPasswordAndConfirm;